/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import type { AppRouter } from '@sidekick/api';
import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import { apiBaseUrl, getIdToken } from './amplify.js';

export const trpc = createTRPCReact<AppRouter>();

export function makeTrpcClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${apiBaseUrl.replace(/\/$/, '')}/trpc`,
        // Cognito JWT injected on every request. The API Gateway JWT
        // authorizer validates it before the Lambda is invoked.
        headers: async () => {
          const token = await getIdToken();
          return token ? { authorization: `Bearer ${token}` } : {};
        },
      }),
    ],
  });
}
